import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import { orderSummaryStages } from "../../constants/orderSummary";
import { dropdownTitle, dropDownStyle } from "./orderDetailsStyles";
import CustomDropdown from "../../common/CustomDropdown";

type UpdateOptionsProps = {
  currentStage: number;
  setCurrentStage: (val: number) => void;
};

export const UpdateOptions: FC<UpdateOptionsProps> = ({
  currentStage,
  setCurrentStage,
}) => {
  const options = orderSummaryStages.slice(1).map((item, idx) => ({
    value: idx + 1,
    label: (
      <Box display="flex" alignItems="center" gap="8px">
        <img src={item.icon} alt={`${item.title}-icon`} />
        {item.title}
      </Box>
    ),
    icon: item.icon,
  }));

  return (
    <Box sx={{ flexDirection: "row", marginLeft: "16px" }}>
      <Typography sx={dropdownTitle} mb={"30px"}>
        Update Order Status
      </Typography>
      <Box sx={dropDownStyle} width="299px">
        <CustomDropdown
          label="Select Status"
          value={currentStage.toString()}
          options={options.map((opt) => ({
            value: opt.value.toString(),
            label: opt.label,
          }))}
          onChange={(selectedValue) => setCurrentStage(Number(selectedValue))}
          menuPlacement="above"
          customStyles={{ button: { borderRadius: "16x" } }}
        />
      </Box>
    </Box>
  );
};
